type Executor<T> = (
	resolve: (value: T | PromiseLike<T>) => void,
	reject: (reason?: any) => void
) => void;

export class LongErrorStackPromise<T> extends Promise<T> {
	constructor(executor: Executor<T>) {
		const dummyError = new Error();
		let doneConstructing = false;

		super((_resolve, _reject) => {
			executor(_resolve, reason => {
				if (doneConstructing) {
					// We finished constructing, so this is an async error
					if (typeof reason === 'undefined') {
						reason = new Error('<undefined>');
					}
					if (reason === null) {
						reason = new Error('<null>');
					} else if (reason === true) {
						reason = new Error('<true>');
					} else if (reason === false) {
						reason = new Error('<false>');
					} else if (typeof reason === 'string') {
						reason = new Error('<string>: ' + reason);
					} else if (typeof reason === 'number') {
						reason = new Error('<number>: ' + reason.toString());
					} else if (typeof reason === 'symbol') {
						reason = new Error('<symbol>: ' + reason.toString());
					}

					if (!reason.stack) {
						reason.stack = '';
					}

					reason.stack +=
						'\n\nPromise stack:\n\n' +
						(dummyError.stack || '').split('\n').slice(2).join('\n');
					_reject(reason);
				} else {
					// We never finished constructing, so this is a sync error during construction, and the stack
					// will already be correct
					_reject(reason);
				}
			});
		});

		doneConstructing = true;
	}
}
